<input type="file" [accept]="fileType()" hidden multiple (change)="dateienSetzen($any($event.target).files)" #input />

@if (dateien().length) {
  <ul class="liste">
    @for (datei of dateien(); track datei.name) {
      <li class="datei">
        <mat-icon>description</mat-icon>
        <span class="datei__name mat-body-medium">{{ datei.name }}</span>
        <span class="datei__groesse mat-body-small">{{ groesse(datei) }}</span>
        <button type="button" mat-icon-button (click)="leeren()" matTooltip="Auswahl entfernen" aria-label="Auswahl entfernen">
          <mat-icon>close</mat-icon>
        </button>
      </li>
    }
  </ul>
  <button type="button" matButton (click)="input.click()">
    <mat-icon>swap_horiz</mat-icon>
    Andere Datei wählen
  </button>
} @else {
  <div
    class="ablage"
    [class.ablage--darueber]="darueber()"
    (dragover)="$event.preventDefault(); darueber.set(true)"
    (dragleave)="darueber.set(false)"
    (drop)="ablegen($event)"
    (click)="input.click()"
    (keydown.enter)="input.click()"
    (keydown.space)="$event.preventDefault(); input.click()"
    tabindex="0"
    role="button"
    [attr.aria-label]="titel()"
  >
    <mat-icon class="ablage__icon">cloud_upload</mat-icon>
    <p class="ablage__titel mat-body-medium">{{ titel() }}</p>
    <p class="ablage__hinweis mat-body-small">Hierher ziehen oder klicken</p>
  </div>
}
